module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/reputacionIcon.a2362b74.svg";